function createIframe(src) {
    return `
    <div style="position: relative; overflow: hidden; height: 0; padding-top: 25px; padding-bottom: 56.25%;">
      <iframe
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        src="${src}" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen
        height="100%" width="100%"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
      >
      </iframe>
    </div>
  `;
}
function getYoutubeVideoIdFromUrl(url) {
    const youtubeRegex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const youtubeMatch = url.match(youtubeRegex);
    if (youtubeMatch && youtubeMatch[7].length == 11) {
        return youtubeMatch[7];
    }
    else {
        return "";
    }
}
export const youtubeEmbedExtension = {
    name: 'youtubeembed',
    level: 'block',
    start(src) {
        var _a;
        return (_a = src.match(/[^\S\r\n]*\n*%\[[^\n]*\]/)) === null || _a === void 0 ? void 0 : _a.index;
    },
    tokenizer(src) {
        const rule = /^[^\S\r\n]*%\[([^\n]*)\]/;
        const cap = rule.exec(src);
        if (cap) {
            const youtube = getYoutubeVideoIdFromUrl(cap[1]);
            if (youtube) {
                const token = {
                    type: 'youtubeembed',
                    raw: cap[0],
                    text: youtube,
                    tokens: []
                };
                return token;
            }
        }
    },
    renderer(token) {
        const videoUrl = "https://www.youtube.com/embed/" + token.text;
        return createIframe(videoUrl);
    }
};
